import React, { useState, useEffect } from "react"
import { Button, ListGroup } from "react-bootstrap"
import { FormattedMessage } from "react-intl"
import ReminderModal from "../../reminder/modals/ReminderModal"
import { isError } from "../../state/helpers/Error"
import ReminderService from "../../state/reminder/ReminderService"
import Icon from "../../common/icon/icon.component"
import Reminder from "../../state/reminder/Reminder"

const UnpaidInvoiceReminderComponent = () => {
    const [showModal, setShowModal] = useState(false)
    const [reminders, setReminders] = useState<Reminder[]>([])
    const [selectedReminder, setSelectedReminder] = useState<Reminder | undefined>(undefined)

    const retrieveReminders = () => {
        ReminderService.RetrieveReminders().then(res => {
            if (!isError(res)) {
                setReminders(res)
            }
        })
    }

    useEffect(() => {
        retrieveReminders()
    }, [])

    const formatReminderRow = (reminder: Reminder) => (
        <ListGroup.Item className="d-flex justify-content-between align-items-center">
            {getMessage(reminder)}
            <Button
                onClick={() => {
                    setShowModal(true)
                    setSelectedReminder(reminder)
                }}
            >
                <Icon value={"edit"} className={"mr-1"} />
                <FormattedMessage
                    id="settings.automation_settings.configure"
                    defaultMessage="Configure"
                />
            </Button>
        </ListGroup.Item>
    )

    return (
        <>
            <div>
                <div className="row ui-has-modules">
                    <label className="col-3 col-form-label text-align-right" style={{ height: "100px" }}>
                        <FormattedMessage
                            id="setting.automationsettings.send_email_reminder"
                            defaultMessage="Send Automatic Payment Invoice Reminder"
                        />
                    </label>
                    <div className="col-9 d-flex align-items-top-center" style={{
                        scrollBehavior: "smooth",
                        overflowY: "scroll",
                        height: "200px"
                    }}>
                        <ListGroup className="w-100">
                            {reminders.map(x => formatReminderRow(x))}
                            <ListGroup.Item>
                                <Button onClick={() => {
                                    setShowModal(true)
                                }}>
                                    <FormattedMessage
                                        id="setting.automationsettings.add_new_reminder"
                                        defaultMessage="Add a new reminder"
                                    />
                                </Button>
                            </ListGroup.Item>
                        </ListGroup>
                    </div>
                </div>
            </div>
            {
                showModal &&
                <ReminderModal

                    onHide={() => {
                        setShowModal(false)
                        setSelectedReminder(undefined)
                    }}
                    onRefresh={() => {
                        retrieveReminders()
                    }}
                    reminder={selectedReminder}
                />
            }
        </>
    )
}

const getMessage = (reminder: Reminder) => {
    return (
        <FormattedMessage
            id="settings.automation_settings.unpaid_invoice_reminder"
            defaultMessage="Send {number} day(s) {period} the due date - {subject}"
            values={{
                number: reminder.getNumberOfDays(),
                period: reminder.getPeriod(),
                subject: reminder.getSubject()
            }}
        />
    )
}

export default UnpaidInvoiceReminderComponent


// WEBPACK FOOTER //
// ./src/automation/components/UnpaidInvoiceReminderComponent.tsx